<template>
    <div>
        <div class="card float-left width100">
            <div class="headingWizard">
                Reschedule Appointment
            </div>
            <div class="card  width100 widthContainer">
                <div class="width100">
                    <div class="formElements">
                        <div class="AppRefText">
                            Appointment Reference ID: {{ appointmentDetails.referenceNumber }}
                            <br />
                            Existing Appointment Date/Time: {{ appointmentDateString }}/ {{
                                formatTime12(appointmentDetails.startTime) }}
                        </div>
                        <p>Note:<br />
                            Requests to change appointment date have to be made at least <strong>2 days</strong> before
                            your appointment
                            date.</p>
                        <div class="">
                            <div class="messagePage">Select New Appointment Date and Time</div>
                            <div class="minSchedulerHeight">
                                <div class="px-10 maxWidthgrid mx-auto text-left">
                                    <div class="grid flex ">
                                        <div class="col-6" v-if="range && range.length > 0">
                                            <p>Select your preferred date</p>
                                        </div>
                                        <div class="col-6" v-if="slotsForSelectedDate?.length > 0">
                                            <p>Select your preferred time</p>
                                        </div>
                                    </div>

                                    <div class="grid">
                                        <div class="p-col-12 p-md-6" v-if="range && range.length > 0">
                                            <div class="calenderControl timeDataHolder">
                                                <vc-date-picker v-model="selectedDate" is-inline
                                                    :attributes="calendarAttributes" :disabled-dates="disabledItems"
                                                    :masks="customMasks" mode="date" :min-date="today"
                                                    :first-day-of-week="0" />

                                            </div>
                                            <div class="flex flex-col gap-2 mt-4 slotDataStyle">
                                                <div class="flex items-center gap-2">
                                                    <span class="h-6 rounded-sm selectedslot slotdatawidth"></span>
                                                    <span>Selected</span>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="h-6 rounded-sm availableslot slotdatawidth"></span>
                                                    <span>Available</span>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="h-6 rounded-sm appointmentfull slotdatawidth"></span>
                                                    <span>Appointment Full</span>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="h-6 rounded-sm notavialableslot slotdatawidth"></span>
                                                    <span>Not Available</span>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="h-6 rounded-sm originalChanged slotdatawidth"></span>
                                                    <span>Original Appointment</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-col-12 p-md-6 timeDataHolder mt-2"
                                            v-if="slotsForSelectedDate?.length > 0">
                                            <div class="text-center p-3 border-round-sm">
                                                {{ formatDateToString(selectedDate) }}
                                            </div>
                                            <div class="mt-1 grid grid-cols-2 gap-2 slotdata"
                                                style="max-height: 300px; overflow-y: auto;">
                                                <div v-for="(slot, index) in slotsForSelectedDate" :key="index"
                                                
                                                    @click="!isPastSlot(slot) && selectSlot(slot, index)" :class="[
                                                        'p-1 text-center cursor-pointer slotStyle max-width',
                                                        isPastSlot(slot) ? 'opacity-50 cursor-not-allowed' :
                                                            slot === originalSlot ? 'originalSlot' :
                                                                slot.isSelected ? 'selected' : '',
                                                        {
                                                            'notAvailable': slot.isBooked,
                                                            'blokedSlot': slot.isBlocked,
                                                            'originallyBooked': slot.isOriginallySelected,
                                                            'originalChanged': slot.isOriginalSlotChanged
                                                        }
                                                    ]">
                                                    {{ apptTime(slot.startTime) }}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="buttonContainer marginTopButton">
                                <div class="p-grid">
                                    <div class="p-col-12">
                                        <div class="float-Left">
                                            <Button type="button" label="< Back" @click="onBack()"
                                                class="linkBtn customLinkCss" />
                                        </div>
                                        <div class="float-Right">
                                            <Button type="submit" tabindex="16" label="Next" @click="onNext()"
                                                class="btn p-button-raised" :disabled="!currentSlot && iscurrentSlot" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref, computed, onMounted, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useApiService } from '@/utils/useApiService'
import { format } from 'date-fns'
//import { defineEmits } from 'vue'
import { useNotifications } from '@/utils/useNotifications'
const { notifyInfoError } = useNotifications()
const emit = defineEmits(['nextClick'])
const { fetchWrapperForGet, fetchWrapperForPut } = useApiService()
const store = useStore()
const router = useRouter()
const slotData = ref([])
const selectedDate = ref(null)

let scheduleInfoModel = reactive(null)
const currentSlot = ref(null)
const previousSlot = ref(null)
const selectedSlot = ref(null)
const id = ref('')
const range = ref([])
const limit = ref(1)
const appointmentDateString = ref('')

const appointmentDetails = ref({
    remarks: '', postBookingMessage: '', vehicleNumber: '', noticeNumber: '', vacNumber: '', serviceId: '', deviceNumber: '',
    parfNumber: '', coeNumber: '', tcoeNumber: '', hvParkNumber: '', serviceName: '', name: '', phoneNumber: '', email: '',
    appointmentDateTime: '', tag: '', referenceNumber: '', generateDateTime: '', numberOfSlots: '', appointmentDate: '', startTime: '', endTime: '', noteToLta: ''
})

const scheduleInfo = ref({ appointmentDate: new Date() })

const isSeq = computed(() => {
    const selectedDate = range.value.find(x => x.isSelected)
    if (selectedDate && selectedDate.appointmentSlots) {
        const selectedSlots = selectedDate.appointmentSlots.filter(x => x.isSelected)
        let index = selectedDate.appointmentSlots.findIndex(x => x.isSelected)
        for (let i = 0; i < selectedSlots.length; i++) {
            if (!selectedDate.appointmentSlots[index]?.isSelected) return false
            index++
        }
    }
    return true
})

const formatDate = (dateStr) => {
    const date = new Date(dateStr)
    if (isNaN(date.getTime())) {
        return ''
    }
    return format(date, 'yyyy-MM-dd')
}
const slotsForSelectedDate = computed(() => {
    if (!selectedDate.value) return []

    const selected = new Date(selectedDate.value)
    if (isNaN(selected.getTime())) return []

    const formatted = format(selected, 'yyyy-MM-dd')

    const day = slotData.value.find(d => {
        const date = new Date(d.date)
        if (isNaN(date.getTime())) return false
        return format(date, 'yyyy-MM-dd') === formatted
    })

    return day?.appointmentSlots || []
})
function formatDateToYMD(date) {
    const d = new Date(date)
    if (isNaN(d)) throw new Error('Invalid date')
    return d.toISOString().split('T')[0]
}
function isPastSlot(slot) {
    const slotDate = new Date(selectedDate.value)
    const [h, m] = slot.startTime.split(':')
    slotDate.setHours(+h, +m, 0, 0)

    const now = new Date()


    const isToday = selectedDate.value.toDateString() === now.toDateString()
    return isToday && slotDate < now
}
const originalSlot = ref(null)
function markOriginalSlot() {
    const originalStart = appointmentDetails.value.startTime
    const originalEnd = appointmentDetails.value.endTime

    const match = slotsForSelectedDate.value.find(
        slot => slot.startTime === originalStart && slot.endTime === originalEnd
    )

    if (match) {
        originalSlot.value = match
    }
}
let iscurrentSlot = reactive(true)
function selectSlot(slot, index) {
    slotsForSelectedDate.value.forEach(s => {
        s.isSelected = false
        s.isOriginalSlotChanged = false
    })

    slot.isSelected = true
    selectedSlot.value = slot

    if (currentSlot.value !== index) {
        previousSlot.value = currentSlot.value
        if (index === 0) {
            iscurrentSlot = false
            currentSlot.value = index
        } else {
            currentSlot.value = index
        }
    }
    if (
        originalSlot.value &&
        slot !== originalSlot.value &&
        originalSlot.value !== null
    ) {
        originalSlot.value.isOriginalSlotChanged = true
    }

    const selectedDay = selectedDate.value

    const selectedDateStr = `${selectedDay.getFullYear()}-${String(selectedDay.getMonth() + 1).padStart(2, '0')}-${String(selectedDay.getDate()).padStart(2, '0')}T00:00:00.0000000+08:00`
    scheduleInfoModel = {
        appointmentDate: selectedDateStr,
        startTime: slot.startTime,
        endTime: slot.endTime,
        originalAppointmentDate: selectedDay,
        originalStartTime: appointmentDetails.value.originalStartTime,
        originalEndTime: appointmentDetails.value.originalEndTime,
        appointmentDateAsString: formatDateToDDMMYYYY(selectedDay)
    }

    store.commit('setScheduleInfo', scheduleInfoModel)
}

function formatDateToDDMMYYYY(date) {
    const d = new Date(date)
    const day = String(d.getDate()).padStart(2, '0')
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const year = d.getFullYear()
    return `${day}-${month}-${year}`
}
function getSchedule() {
    fetchWrapperForGet(`api/mopappointments/appointmentschedule`, false, false).then(data => {
        if (!data) return

        data.forEach(value => {
            const [yyyy, mm, dd] = value.date.split('T')[0].split('-')
            value.date = new Date(yyyy, mm - 1, dd)
        })

        range.value = data
        slotData.value = data
        const appointment = appointmentDetails.value
        const selectedDateObj = appointment.appointmentDate
        selectedDate.value = selectedDateObj
        function formatDateToYMD(date) {
            const d = new Date(date);
            if (isNaN(d)) {
                throw new Error('Invalid date');
            }
            return d.toISOString().split('T')[0];
        }
        const selectedDay = slotData.value.find(d => formatDateToYMD(d.date) === formatDateToYMD(selectedDateObj))
        if (selectedDay) {
            selectedDay.appointmentSlots.forEach((day, i) => {
                if (day.startTime == appointment.startTime) {
                    day.isSelected = true
                    selectedDay.isSelected = true
                    selectSlot(day, i)
                    markOriginalSlot()
                }
            })

        }
    })
}
const noOfSlots = computed(() => {
    const selectedDate = range.value.find(x => x.isSelected === true)
    return selectedDate?.appointmentSlots?.filter(x => x.isSelected).length || 0
})

function onNext() {
    const selectedDateObj = scheduleInfoModel;

    const appointmentDate = selectedDateObj?.appointmentDate || appointmentDetails.value.appointmentDate;
    const startTime = selectedDateObj?.startTime || appointmentDetails.value.startTime;
    const endTime = selectedDateObj?.endTime || appointmentDetails.value.endTime;
    const numberOfSlots = selectedDateObj.length || appointmentDetails.value.numberOfSlots || 1;

    const dataModel = {
        serviceId: appointmentDetails.value.serviceId,
        appointmentDate,
        startTime,
        endTime,
        AppointmentDateAsString: formatApptDate(appointmentDate),
        numberOfSlots,
        id: id.value
    };

    fetchWrapperForGet(`api/HeartBeat`, false, false).then(() => {
        fetchWrapperForPut(`api/appointments/schedule`, dataModel, false, true, true).then(data => {
            if (data || data === '') {
                const transDt = store.getters.getTransactionDateString;
                store.dispatch('reset').then(() => {
                    Object.assign(appointmentDetails.value, dataModel);
                    const appDt = apptRescheduleDateFormat(dataModel.appointmentDate);

                    store.dispatch('setAppointmentDateString', appDt).then(() => {
                        store.dispatch('setTransactionDateString', transDt).then(() => {
                            store.dispatch('setAppointmentAcknowlegement', appointmentDetails.value).then(() => {
                                emit('nextClick');
                            });
                        });
                    });
                });
            }
        });
    }).catch(err => {
        if (err.errorCode === 422) {
            notifyInfoError("Your session has expired due to inactivity. To download appointment details, please select \"Enquire / Manage Appointment\" option and try again.", okFunction);
        } else {
            notifyError(err);
            getSchedule();
        }
    });
}
function formatDateToString(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString('default', { month: 'long' });
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
    const year = d.getFullYear();
    return `${day}-${capitalizedMonth}-${year}`;
}
const calendarAttributes = computed(() => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const baseAttributes = slotData?.value.map(d => {
        const date = new Date(d.date)
        date.setHours(0, 0, 0, 0)

        let type = 'notAvailable'

        if (date < today) {
            type = 'notAvailable'
        } else {
            const hasAvailable = d.appointmentSlots?.some(slot =>
                !slot.isBlocked && !slot.isBooked && !slot.isReserved
            )
            type = hasAvailable ? 'available' : 'notAvailable'
        }

        return {
            key: `${type}-${date.toDateString()}`,
            dates: date,
            highlight: {
                class: type === 'available' ? 'available-slot' : 'not-available-slot',
                contentClass: type === 'available' ? 'available-slot-text' : 'not-available-slot-text'
            }
        }
    }) || []

    baseAttributes.push({
        key: 'selected-date',
        dates: selectedDate.value,
        highlight: {
            class: 'selected-slot',
            contentClass: 'selected-slot-text'
        }
    })

    slotData?.value.forEach(d => {
        if (d.isBooked && d.isBlocked) {
            const date = new Date(d.date)
            date.setHours(0, 0, 0, 0)

            baseAttributes.push({
                key: `booked-${date.toDateString()}`,
                dates: date,
                highlight: {
                    class: 'bothblockedandbook',
                    contentClass: 'booked-slot-both'
                }
            })
        }
        else if (d.isBooked) {
            const date = new Date(d.date)
            date.setHours(0, 0, 0, 0)

            baseAttributes.push({
                key: `booked-${date.toDateString()}`,
                dates: date,
                highlight: {
                    class: 'booked',
                    contentClass: 'booked-slot-text'
                }
            })
        }
    })

    baseAttributes.push({
        key: 'selected-date',
        dates: selectedDate.value,
        highlight: {
            class: 'selected-slot',
            contentClass: 'selected-slot-text'
        }
    })


    baseAttributes.push({
        key: 'today-date',
        dates: today,
        highlight: {
            class: 'today-slot',
            contentClass: 'today-slot-text'
        }
    })

    return baseAttributes
})

function apptTime(value) {
    if (value) {
        const [hours, minutes, seconds] = value.split(':').map(Number);
        const date = new Date();
        date.setHours(hours, minutes, seconds || 0);

        let hour = date.getHours();
        const minute = date.getMinutes();
        const ampm = hour >= 12 ? 'PM' : 'AM';

        hour = hour % 12;
        hour = hour ? hour : 12; // the hour '0' should be '12'

        const minuteStr = minute < 10 ? '0' + minute : minute;
        return `${hour}:${minuteStr} ${ampm}`;
    }
    return value;
}
const today = new Date()
today.setHours(0, 0, 0, 0)

const endDate = new Date(today)
endDate.setDate(endDate.getDate() - 1)

const disabledItems = computed(() => {
    const noSelectable = []
    for (let i = 0; i < slotData.value.length; i++) {
        const item = slotData.value[i]
        if (item.isBooked || item.isBlocked) {
            noSelectable.push(new Date(item.date))
        }
    }
    return noSelectable
})
function onBack() {
    emit('backClick')

}
const customMasks = {
    weekdays: 'WW'
}
function okFunction() {
    fetchWrapperForGet(`api/MopSessions/Delete`, false, false, true).then(() => {
        store.dispatch('reset').then(() => {
            window.location.reload()
        })
    })
}

// function formatApptDate(date) {
//     const d = new Date(date);
//     const day = String(d.getDate()).padStart(2, '0');
//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const year = d.getFullYear();
//     return `${day}-${month}-${year}`;
// }
function formatApptDate(dateStr) {
  const [yyyy, mm, dd] = dateStr.split('T')[0].split('-')
  return `${dd}-${mm}-${yyyy}`
}
function apptRescheduleDateFormat(date) {
    return formatApptDate(date)
}

onMounted(() => {
    id.value = store.getters.getAppointmentId
    Object.assign(appointmentDetails.value, JSON.parse(JSON.stringify(store.getters.getAppointmentAcknowlegement)))
    const [yyyy, mm, dd] = appointmentDetails.value.appointmentDate.split("T")[0].split("-")
    appointmentDetails.value.appointmentDate = new Date(yyyy, mm - 1, dd)
    appointmentDateString.value = store.getters.getAppointmentDateString
    getSchedule()
})
function formatTime12(value) {
    if (value) {
        const [hoursStr, minutesStr] = value.split(':');
        let hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${hours}:${String(minutes).padStart(2, '0')} ${ampm}`;
    }
    return value;
}
</script>

<style scoped>
.AppRefText {
    padding: 10px;
    border: 1px solid #a6a6a6;
}

.noteText {
    margin: 20px 0;
}

.slotStyle {
    width: 33%;
    background: #fecd20;
    line-height: 20px;
    color: black !important;
    font-size: 13px !important;
    margin: 2px 0 0 0 !important;
}

.vc-day-content.vc-disabled {
    background-color: #eee !important;
    color: #aaa !important;
    border-radius: 50%;
}
.blokedSlot {
    background-color: #e6e6e6 !important;
    pointer-events: none !important;
    opacity: 0.5 !important;
    color: #848484;
}

::v-deep(.vc-highlight.vc-day-box-center-center.available-slot) {
    background-color: #fecd20 !important;
    border-radius: 0 !important;
    width: 100% !important;
    height: 36px !important;
    margin: 10px auto;
}


::v-deep(.vc-day-content .available-slot-text) {
    color: #000 !important;
    font-weight: bold;
}

::v-deep(.vc-highlight.not-available-slot) {
    background-color: #e6e6e6 !important;
    border-radius: 0 !important;
    width: 100% !important;
    padding: 18px 40px !important;
    cursor: default !important;
    pointer-events: none !important;
    opacity: 0.5 !important;
}




.vc-day-content:hover {
    background-color: transparent !important;
}


.calenderControl {
    margin-right: 30px;
}



.slotdata {
    display: flex !important;
    justify-content: center !important;
}

.selected {
    background-color: #3e50a0 !important;
    color: #ffff !important;
}

.messagePage {
    font-weight: 900;
    margin: 0 0 10px 0;
    font-size: 18px;
    margin-top: 15px;
}

.slotDataStyle {
    display: flex !important;
    flex-direction: column !important;
}

.slotdatawidth {
    width: 20px !important;
}

.timeDataHolder {
    border: 1px solid #a6a6a6;
    padding: 10px;
    border-radius: 5px;
    height: 396px;
    overflow: hidden;
}

.marginLeftTime {
    margin-left: 30px;
}

.opacity-50 {
    opacity: 0.5;
}

.cursor-not-allowed {
    background-color: #e6e6e6 !important;
    cursor: not-allowed;
}

.available-slot {
    background-color: #e0f7fa;
}



.selected-slot {
    background-color: #007bff !important;
    color: white !important;
    border-radius: 50%;
}

.selected-slot-text {
    color: white !important;
    font-weight: bold;
}

.prevSlot {
    background-color: #9ba9e4;

}


.originalSlot {
    background-color: #3e50a0;
    color: white !important;
}

.widthContainer {
    padding: 15px;
}

@media all and (min-width: 900px) {
    .widthContainer {
        width: 80%;
        margin: 87px auto
    }
}

.originalChanged {
    background-color: #9ba9e4 !important;
    border: 1px dashed #9ba9e4 !important;
    color: #333333 !important;
}
</style>